//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getSurveyQuestion, postSurvey } from '@/api/youzheng'
export default {
  data () {
    return {
      paperid: 1073,
      active: 0,
      list: [],
      submitList: [],
      showResult: false,
      resultObj: {}
    }
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    }
  },
  mounted () {
    // 获取问答题目
    this.getList()
  },
  methods: {
    getList () {
      getSurveyQuestion({
        paperid: this.paperid,
        accountid: this.accountid
      }).then(res => {
        this.list = res.returnValue.ROWLIST
      })
    },
    submit () {
      postSurvey({
        paperid: this.paperid,
        accountid: this.accountid,
        submitList: JSON.stringify(this.submitList)
      }).then(res => {
        this.showResult = true
        this.resultObj = res.returnValue
      })
    },
    onChange (id, subid, index) {
      // 答案只有单选且都是“是”和“否
      if (this.list[index].TYPE === 1) {
        this.$set(this.submitList, index, {
          subjectid: id,
          optionList: [
            {
              optionid: subid
            }
          ]
        })
      }
      if (index === this.list.length - 1) {
        // 提交
        this.submit()
      } else {
        this.active++
      }
    }
  }
}
